import { DeckGroup } from "./deck-group";

export class DeckGroupColumn {
    public groups: DeckGroup[] = [];

    public constructor(public index: number) { }
}